import { render, staticRenderFns } from "./paystar.vue?vue&type=template&id=2c0813be"
import script from "./paystar.vue?vue&type=script&lang=js"
export * from "./paystar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports